import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import Resize from 'vuetify/lib/directives/resize';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VCard,
    [
      _c(
        VCardTitle,
        { staticClass: "text-h5 font-weight-bold" },
        [
          _vm._v(" COA Preview - " + _vm._s(_vm.labResult.averoutN) + " "),
          _c(VSpacer),
          _c(
            VBtn,
            {
              attrs: { icon: "" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_c(VIcon, [_vm._v("mdi-close")])],
            1
          ),
        ],
        1
      ),
      _c(VDivider),
      _c(
        VCardText,
        { staticClass: "pa-0" },
        [
          _c(
            VContainer,
            { staticClass: "pa-4 pa-md-6", attrs: { fluid: "" } },
            [
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12", md: "7" } },
                    [
                      _c(
                        VCard,
                        {
                          staticClass: "pdf-preview-card",
                          attrs: { outlined: "" },
                        },
                        [
                          _c(
                            VCardTitle,
                            {
                              staticClass: "text-subtitle-1 font-weight-medium",
                            },
                            [_vm._v(" PDF Preview ")]
                          ),
                          _c(VDivider),
                          _c(
                            VCardText,
                            { staticClass: "pa-0" },
                            [
                              _vm.pdfPreviewUrl
                                ? _c("iframe", {
                                    staticClass: "pdf-iframe",
                                    attrs: { src: _vm.pdfPreviewUrl },
                                  })
                                : _c(VSkeletonLoader, {
                                    attrs: { type: "image", height: "500" },
                                  }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.labResult.finalTest && !_vm.labResult.signed
                    ? _c(
                        VCol,
                        { attrs: { cols: "12", md: "5" } },
                        [
                          _c(
                            VCard,
                            {
                              staticClass: "signature-card",
                              attrs: { outlined: "" },
                            },
                            [
                              _c(
                                VCardTitle,
                                {
                                  staticClass:
                                    "text-subtitle-1 font-weight-medium",
                                },
                                [_vm._v(" Sign Off ")]
                              ),
                              _c(VDivider),
                              _c(
                                VCardText,
                                [
                                  _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex justify-space-between",
                                      },
                                      [
                                        _c("span", { staticClass: "my-auto" }, [
                                          _vm._v(_vm._s(_vm.signatureHeader)),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-center signature-pad my-2",
                                      on: { click: _vm.openSignMode },
                                    },
                                    [
                                      _vm.signatureSvg
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                position: "absolute",
                                                "margin-top": "-30px",
                                              },
                                            },
                                            [
                                              _c(VImg, {
                                                attrs: {
                                                  contain: "",
                                                  "aspect-ratio": 16 / 9,
                                                  "max-height": "100px",
                                                  "max-width": "200px",
                                                  src: _vm.signatureSvg,
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-center font-weight-thin my-auto mx-10",
                                            },
                                            [
                                              _vm._v(" Sign Here "),
                                              _c(VIcon, [
                                                _vm._v("mdi-draw-pen"),
                                              ]),
                                            ],
                                            1
                                          ),
                                    ]
                                  ),
                                  _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex justify-space-between",
                                      },
                                      [
                                        _vm.signatureFooter
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-space-between",
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "( " +
                                                      _vm._s(
                                                        _vm.signatureFooter
                                                      ) +
                                                      " )"
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _c("span", [_vm._v("N/A")]),
                                      ]
                                    ),
                                  ]),
                                  _vm.signatureError
                                    ? _c(
                                        VAlert,
                                        {
                                          staticClass: "mt-4",
                                          attrs: {
                                            type: "error",
                                            outlined: "",
                                          },
                                        },
                                        [_vm._v(" Signature is required ")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                VCardActions,
                                [
                                  _c(VSpacer),
                                  _c(
                                    VBtn,
                                    {
                                      attrs: {
                                        color: "primary",
                                        loading: _vm.loading,
                                      },
                                      on: { click: _vm.submitSignature },
                                    },
                                    [_vm._v(" Submit Signature ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm.labResult.signed
                    ? _c(
                        VCol,
                        { attrs: { cols: "12", md: "5" } },
                        [
                          _c(
                            VCard,
                            {
                              staticClass: "signed-card",
                              attrs: { outlined: "" },
                            },
                            [
                              _c(
                                VCardTitle,
                                {
                                  staticClass:
                                    "text-subtitle-1 font-weight-medium",
                                },
                                [_vm._v(" Already Signed ")]
                              ),
                              _c(VDivider),
                              _c(
                                VCardText,
                                { staticClass: "text-center" },
                                [
                                  _c(
                                    VIcon,
                                    { attrs: { large: "", color: "green" } },
                                    [_vm._v("mdi-check-circle")]
                                  ),
                                  _c("p", { staticClass: "mt-2" }, [
                                    _vm._v("This lab result has been signed."),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VDialog,
        {
          directives: [
            {
              def: Resize,
              name: "resize",
              rawName: "v-resize",
              value: _vm.onResize,
              expression: "onResize",
            },
          ],
          staticStyle: { "z-index": "1000" },
          attrs: { fullscreen: _vm.$vuetify.breakpoint.xsOnly, persistent: "" },
          model: {
            value: _vm.signMode,
            callback: function ($$v) {
              _vm.signMode = $$v
            },
            expression: "signMode",
          },
        },
        [
          _c(
            VCard,
            { staticClass: "pt-5" },
            [
              _c(
                VCardSubtitle,
                { staticClass: "d-flex" },
                [
                  _c("div", { staticClass: "my-auto" }, [_vm._v("Sign Below")]),
                  _c(VSpacer),
                  _c(
                    VBtn,
                    { attrs: { icon: "" }, on: { click: _vm.closeDialog } },
                    [_c(VIcon, [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                VCardText,
                { staticClass: "px-4" },
                [
                  _c(
                    VSheet,
                    { attrs: { elevation: 2 } },
                    [
                      _vm.loaded
                        ? _c("vue-signature", {
                            key: _vm.windowSize.x,
                            ref: "signaturePad",
                            attrs: {
                              h: `${
                                _vm.windowSize.x / 3 < 200
                                  ? 200
                                  : _vm.windowSize.x / 3
                              }px`,
                              w: `${
                                _vm.windowSize.x * 0.8 < 300
                                  ? 300
                                  : _vm.windowSize.x * 0.8
                              }px`,
                              sigOption: _vm.option,
                              defaultUrl: _vm.tempSignatureSvg,
                            },
                            on: { beginStroke: _vm.onBeginStroke },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VCardActions,
                { staticClass: "d-flex justify-center" },
                [
                  _c(
                    VBtn,
                    { staticClass: "ma-2", on: { click: _vm.saveSignature } },
                    [
                      _c(VIcon, { staticClass: "mr-2" }, [
                        _vm._v("mdi-content-save"),
                      ]),
                      _c("span", [_vm._v("Done")]),
                    ],
                    1
                  ),
                  _c(
                    VBtn,
                    {
                      staticClass: "ma-2",
                      on: { click: _vm.clearSignaturePad },
                    },
                    [
                      _c(VIcon, { staticClass: "mr-2" }, [
                        _vm._v("mdi-eraser"),
                      ]),
                      _c("span", [_vm._v("Clear")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }